import { useLocation } from 'react-router';

import { OppByTaskTypeChart } from '../../charts/OppByTaskChart';
import { TotalTaskOppChart } from '../../charts/TotalTaskOppChart';
import {
  getHygieneOpportunity,
  getHygieneOpportunityByTask,
} from '../../helpers/hygieneOpportunity';
import type { THygienePracticeRates } from '../../types';
import { PracticeHeader } from '../PracticeHeader';

import { HygienePracticeTable } from './HygienePracticeTable';

export const PracticeHygiene = ({
  hygienePracticeRates,
}: {
  hygienePracticeRates: THygienePracticeRates[];
}) => {
  const location = useLocation();
  const id =
    location.pathname.split('practice/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('practice/')[1]?.split('/')[0];
  const name = hygienePracticeRates?.find(
    (practice) => practice?.practiceId.toString() === id,
  )?.practiceName;

  const practiceRatesHygiene = hygienePracticeRates.find(
    (practice) => practice.practiceId.toString() === id,
  );

  const totalOpportunityHygiene = getHygieneOpportunity(practiceRatesHygiene);
  const opportunityByTaskHygiene =
    getHygieneOpportunityByTask(practiceRatesHygiene);

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-px-8 vai-py-4">
      <PracticeHeader practiceName={name} />
      <div className="vai-flex vai-flex-row vai-gap-4">
        <TotalTaskOppChart totalOpp={totalOpportunityHygiene} />
        <OppByTaskTypeChart opportunityByTask={opportunityByTaskHygiene} />
      </div>
      <HygienePracticeTable providers={practiceRatesHygiene?.hygienists} />
    </div>
  );
};
